.card,
.cardCollapsed {
  position: fixed !important;
  z-index: 999;
  bottom: 60px;
  left: 195px;
  height: 580px;
  width: 450px;
}

.cardCollapsed {
  left: 95px;
}

.cardMobile,
.cardMobileWithHeygen {
  position: fixed !important;
  z-index: 1200;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
}

.cardMobileWithHeygen {
  top: 40vh;
  height: 60vh;
}

.heygenContainer,
.heygenContainerCollapsed {
  position: fixed !important;
  border-radius: 25px;
  background-color: rgb(175 175 175 / 60%) !important;
  z-index: 999;
  width: 436px;
  height: 436px;
  bottom: 204px;
  left: 655px;
}

.heygenContainerCollapsed {
  left: 555px;
}

.heygenMobile,
.heygenMobileFullScreen {
  position: fixed !important;
  background-color: rgb(15 25 15 / 70%) !important;
  z-index: 1250;
  top: 0;
  left: 0;
  width: 100vw;
  height: 40vh;
}

.heygenMobileFullScreen {
  height: 100vh;
}

.btn,
.btnCollapsed {
  position: fixed !important;
  z-index: 999;
  left: 20px;
  bottom: 60px;
  height: 46px !important;
  width: 133px !important;
}

.btnCollapsed {
  left: 12px;
  width: 52px !important;
  border: 1px solid #4e91f4 !important;
}

.btnText {
  color: #3d80f3 !important;
  font-size: 14px;
  font-weight: 600;
}

.close {
  cursor: pointer;
}

.close:hover {
  font-weight: bold;
}

.titleIconContainer {
  position: relative;
  margin: 0 12px 0 0;
  background: rgb(61 128 243 / 30%);
  width: 32px;
  height: 32px;
  border-radius: 16px;
}

.titleIconContainer > svg {
  position: absolute;
  top: 7px;
  left: 7px;
}

.controls {
  position: sticky;
  padding: 20px 15px;
  border-top: 1px solid #eee;
  width: 100%;
  height: 56px;
}

.input {
  max-width: 75%;
  padding-right: 2px !important;
}

.micBtn {
  padding: 0 !important;
  margin: 0 !important;
}

.micBtnAvatar {
  height: 36px !important;
  width: 36px !important;
}

.sendBtn {
  height: 36px !important;
  width: 36px !important;
}

.sendIcon {
  transform: scale(0.8);
  margin: 4px 1px 0 0;
}

.micDef,
.micRec {
  transform: scale(0.8);
  padding-top: 2px !important;
}

.micDefAvatar,
.micRecAvatar {
  transform: scale(0.9);
  margin: 1px 0 0;
}

.micDef > path {
  stroke: #b3b3b3 !important;
}

.micRec > path {
  stroke: rgb(235 35 35) !important;
}

.micDefAvatar > path {
  stroke: #b3b3b3 !important;
}

.micRecAvatar > path {
  stroke: #fff !important;
}

.quoteIcon {
  cursor: pointer;
}

.promptIdeasCard {
  width: 345px;
  height: 341px;
  background-color: #f4f4f4 !important;
  margin-bottom: 30px !important;
  border: 1px solid #eee;
}

.promptIdeasRow {
  padding: 10px;
  margin: 10px 20px;
  background-color: #fff;
  font-size: 12px;
  border-radius: 10px;
  cursor: pointer;
  border: 1px solid #eee;
}

.promptIdeasRow:hover {
  border: 1px solid #aaa;
}

.promptIdeasIcon {
  fill: #181818;
  transform: scale(0.6);
  margin-top: 4px;
}

.messages,
.messagesMobile,
.messagesMobileWithHeygen {
  padding: 15px;
  height: 440px;
  width: 100%;
  overflow-y: scroll;
  overscroll-behavior: none;
}

.messagesMobile {
  height: calc(100vh - 150px);
}

.messagesMobileWithHeygen {
  height: calc(60vh - 150px);
}

.msg {
  width: 100%;
}

.msgText {
  max-width: 82%;
  margin: 5px;
  padding: 15px;
  overflow-wrap: anywhere;
  font-size: 14px;
  white-space: pre-wrap;
}

.msgCopy {
  padding: 0 15px;
}

.msgCopyIcon {
  cursor: pointer;
}

.msgUser {
  background-color: #3d80f3;
  border-radius: 30px 30px 0;
  color: #fff;
}

.msgAssistant {
  background-color: #f4f4f4;
  border-radius: 30px 30px 30px 0;
  color: #181818;
}

.msgSpecial {
  background-color: #cee0ff;
  border-radius: 30px 30px 30px 0;
  color: #181818;
  margin-bottom: 30px;
}

.msgTime {
  font-size: 10px;
  color: #b3b3b3;
  padding: 0 5px;
}

.aiSwitch {
  margin-right: 40px !important;
}

.aiSwitchIcon {
  position: absolute;
  top: 6px;
  left: 6px;
}

.videoContainer,
.videoContainerMobile {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.videoContainer {
  border-radius: 25px;
}

.avatarBtn {
  position: absolute !important;
  z-index: 999;
  background-color: rgb(35 35 35 / 60%) !important;
  border: 1px solid #757575 !important;
}

.avatarBtn:hover {
  border: 1px solid #ccc !important;
}

.avatarMicBtn,
.avatarMicBtnRed {
  left: 10px;
  top: 165px;
}

.avatarMicBtnRed {
  background-color: rgb(235 35 35 / 60%) !important;
}

.interruptBtn {
  bottom: 40px;
}

.avatarTopText {
  position: absolute !important;
  z-index: 999;
  top: 5px;
}

.avatarBeforeBtnText {
  position: absolute !important;
  z-index: 999;
  top: 35%;
  width: 50%;
  text-align: center;
  font-size: 14px;
  font-weight: 550;
}

.avatarStartConversationBtn,
.avatarStartConversationBtnCenter {
  position: absolute !important;
  z-index: 999;
  top: 58%;
  transform: translate(0, -58%);
  background-color: #3d80f3 !important;
}

.avatarStartConversationBtnCenter {
  top: 50%;
  transform: translate(0, -50%);
}

.avatarAfterBtnText {
  position: absolute !important;
  z-index: 999;
  top: 65%;
  font-size: 12px;
  color: #c5c5c5 !important;
}

.avatarTextCenter {
  position: absolute !important;
  z-index: 999;
  top: 50%;
  transform: translate(0, -50%);
  font-size: 18px;
  width: 70%;
  text-align: center;
}

.avatarTrilaText {
  position: absolute !important;
  z-index: 999;
  top: 20px;
  left: 25px;
  font-size: 14px;
  width: 65%;
  text-align: left;
  color: #f8f8f8;
}

.countDown {
  right: 10px;
  bottom: 8px;
  color: #f8f8f8;
  border-radius: 10px;
  padding: 3px 5px;
}

.poweredBy,
.poweredByWhite {
  position: absolute !important;
  bottom: 8px;
  z-index: 999;
  color: #111 !important;
  text-shadow: 0 0 2px #fff;
}

.poweredByWhite {
  color: #fff !important;
  text-shadow: 0 0 2px #111;
}

.poweredByIcon {
  filter: drop-shadow(0 0 6px #fff);
}

.poweredByIconWhite {
  fill: #fff;
  filter: drop-shadow(0 0 6px #111);
}

.poweredByCompanyName,
.poweredByCompanyNameWhite {
  font-weight: bold;
  color: #111 !important;
}

.poweredByCompanyNameWhite {
  color: #fff !important;
}

.interruptBtnTxt {
  color: #fff !important;
  font-size: 14px;
}

.volumeControl {
  top: 10px;
  left: 10px;
  border-radius: 15px;
  height: 150px;
  width: 37px;
}

.volumeControlIcon {
  margin: 12px 5px 2px;
}

.volumeControlSlider {
  height: 94px !important;
  padding: 0 6px !important;
  margin: 0 5px !important;
}

.expandBtn {
  right: 10px;
  top: 10px;
  width: 40px !important;
  height: 40px !important;
}

.expandBtnIcon {
  margin: 8px 0 0 1px;
}

.collapseBtnIcon {
  transform: scale(0.6);
  margin: -3px 0 0 -1px;
}

.blured {
  filter: blur(17px);
}

.expirationCard {
  position: absolute !important;
  top: calc(40% - 30px);
  left: 50%;
  transform: translate(-50%, 0);
  overscroll-behavior: none;
  border: 1px solid #3d80f3;
  width: 90%;
  padding: 0 !important;
  background-color: #f4f4f4 !important;
  cursor: pointer;
}

.expirationCardIcon {
  margin-top: 10px;
}

.expirationCardDescription {
  color: #3d80f3 !important;
  font-size: 16px;
  font-weight: 500;
}

.expirationCardLink {
  color: #3d80f3 !important;
  font-size: 12px;
  font-weight: 900;
  cursor: pointer;
}

.poweredByModal {
  color: #111 !important;
  text-shadow: 0 0 2px #fff;
}

.blueText {
  color: #3d80f3 !important;
}

.whiteText {
  color: #fff !important;
}

.modalCard,
.modalCardPrimary {
  position: relative;
  margin: 10px !important;
  width: 300px;
  height: 330px;
  background-color: #f4f4f4 !important;
}

.modalCardPrimary {
  border: 1px solid #3d80f3;
  background-color: rgb(61 128 243 / 10%) !important;
}

.modalCardTitle {
  font-size: 32px;
  font-weight: bold;
}

.modalCardFeatures {
  font-size: 12px;
  margin: 5px 0;
}

.modalCardFeaturesLine {
  margin: 7px 0;
}

.modalCardFeaturesBasicCheck,
.modalCardFeaturesPremiumCheck,
.modalCardFeaturesPremiumCheckDark {
  margin: 2px 10px 0 0;
}

.modalCardButton {
  position: absolute;
  left: 36px;
  bottom: 10px;
}

.modalNavDefault,
.modalNavPrimary {
  width: 100px;
  border-radius: 10px !important;
}

.modalNavDefault {
  background-color: #f1f1f1 !important;
  color: #414141 !important;
  border: 0 !important;
  margin-right: 20px;
}

.modalCardCheckout,
.modalCardCheckoutPrimary {
  min-height: 132px;
  background-color: #f4f4f4 !important;
}

.modalCardCheckoutPrimary {
  border: 1px solid #3d80f3;
  background-color: rgb(61 128 243 / 10%) !important;
}

.modalCheckoutContent {
  padding: 15px 0;
  justify-content: flex-start !important;
}

.modalCheckoutFeaturesTitle {
  font-size: 20px;
  font-weight: 600;
}

.modalCheckoutFeaturesContent {
  font-size: 16px;
}

.modalCheckoutFeaturesLine {
  font-size: 16px;
  padding: 7px 0;
}

.modalCheckoutFeaturesBasicCheck,
.modalCheckoutFeaturesPremiumCheckDark {
  margin: 6px 10px 0 0;
}

.modalCardFeaturesPremiumCheck > path {
  fill: #3d80f3;
}

.modalCardFeaturesPremiumCheckDark > path {
  fill: #0057a5;
}

.modalCheckoutFeaturesPremiumCheckDark > path {
  fill: #0057a5;
}

.micDef:hover > path {
  stroke: #939393 !important;
}

.msgCopyIcon:hover > path {
  stroke: #939393 !important;
}

@keyframes dotty {
  0% { content: ""; }
  25% { content: "."; }
  50% { content: ".."; }
  75% { content: "..."; }
  100% { content: ""; }
}

.connectingText {
  display: inline-block;
  width: 18px;
  color: #fff !important;
}

.connectingText::after {
  display: inline-block;
  animation: dotty steps(1, end) 3s infinite;
  content: "";
}
